import React, { Component } from 'react';
import logo from './logo.svg';
import Steppers from './component/Stepper/Steppers';
import Scroller from './component/Scroll/Scroll';
import Highlight from './component/highlights/highlights';
import {Element} from 'react-scroll';

import './App.css';

class App extends Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          {/* <img src={logo} className="App-logo" alt="logo" /> */}
          <p>
            CPS_Week1_Stillness_Scroll to Animation
          </p>
        
        </header>
        <Scroller/>
        <Steppers/>
        <Element name="highlights">
         <Highlight/>
        </Element>
       
      </div>
    );
  }
}

export default App;
